import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iDetailLibraryDetailState {
    response : {
        library_name: string;
        created_at: string;
        created_round : string[];
        run_round : string[];
        user_email  : string;
        workflow_name: string;
        assay_use : boolean;
        workflow_type:string;
    };
    isLoading : boolean;
    message : string | null;
}

const initialState: iDetailLibraryDetailState = {
    response : {
        library_name: "",
        created_at: "",
        created_round : [],
        run_round : [],
        user_email  : "",
        workflow_name: "",
        assay_use : false,
        workflow_type : ""
    },
    isLoading: false,
    message: "",
};
// List Library API 호출
export const detailLibraryAPI = createAsyncThunk(
    "DETAIL_LIBRARY",
    async (params: {group_name : string , library_name : string}, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/library/detail/';
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}?group_name=${params.group_name}&library_name=${params.library_name}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// List Library Slice
export const detailLibrarySlice = createSlice({
    name: "detailLibrary",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(detailLibraryAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(detailLibraryAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(detailLibraryAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    }
});

export default detailLibrarySlice.reducer;